export default __webpack_public_path__ + "static/Wintomato_1293x120-aa39c207938af2433f6d4d1f1cd57270.png";